<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import * as Alert from "$lib/components/ui/alert";

  interface Props {
    inlineError: string | null;
    onScan: () => void;
    onPhoto: () => void;
  }
  const { inlineError, onScan, onPhoto }: Props = $props();
</script>

<section class="scanlet-shell flex min-h-dvh flex-col justify-between p-5 sm:p-8">
  <header class="flex items-center justify-between gap-4 font-sans text-xs uppercase tracking-[0.28em] text-muted-foreground">
    <span>Offline pocket scanner</span>
    <span class="rounded-full border border-border px-3 py-1 text-[0.65rem] text-accent">PWA</span>
  </header>

  <div class="mx-auto flex w-full max-w-[34rem] flex-1 flex-col justify-center gap-7 py-10">
    <div class="glass-panel relative overflow-hidden rounded-[2rem] p-5 sm:p-7">
      <div class="absolute -right-12 -top-14 h-44 w-44 rounded-full bg-accent/20 blur-3xl"></div>
      <div class="paper-card relative rotate-[-2deg] rounded-[1.55rem] p-7 shadow-2xl">
        <div class="mb-10 flex items-start justify-between gap-6">
          <div class="grid size-16 place-items-center rounded-2xl bg-background text-primary shadow-inner">
            <img src="/icons/icon-192.png" alt="" width="42" height="42" class="rounded-xl" />
          </div>
          <div class="font-sans text-right text-[0.62rem] uppercase tracking-[0.22em] text-foreground/45">
            Local only<br />No cloud<br />No account
          </div>
        </div>
        <p class="font-sans text-xs font-semibold uppercase tracking-[0.34em] text-foreground/55">Scanlet</p>
        <h1 class="mt-2 max-w-sm text-5xl font-black leading-[0.88] tracking-[-0.08em] sm:text-6xl">
          Turn paper into signal.
        </h1>
        <p class="mt-5 max-w-xs font-sans text-sm leading-6 text-foreground/70">
          Capture documents, trim the frame, assemble a PDF, and share it from your browser.
        </p>
      </div>
    </div>

    {#if inlineError}
      <Alert.Root variant="destructive" class="max-w-sm border-destructive/40 bg-destructive/15 text-destructive-foreground">
        <Alert.Description>{inlineError}</Alert.Description>
      </Alert.Root>
    {/if}

    <div class="grid gap-3 sm:grid-cols-2">
      <Button
        size="lg"
        class="h-16 rounded-2xl bg-primary text-base font-black text-primary-foreground shadow-[0_18px_45px_oklch(0.84_0.144_83/0.22)] hover:translate-y-[-1px] hover:bg-primary"
        onclick={onScan}
      >Scan document</Button>
      <Button
        size="lg"
        variant="outline"
        class="h-16 rounded-2xl border-border/70 bg-white/5 text-base font-black text-foreground shadow-xl backdrop-blur hover:translate-y-[-1px] hover:bg-white/10"
        onclick={onPhoto}
      >Take photo</Button>
    </div>
    <div class="grid grid-cols-3 gap-2 font-sans text-[0.68rem] uppercase tracking-[0.18em] text-muted-foreground">
      <span class="rounded-full border border-border px-3 py-2 text-center">Crop</span>
      <span class="rounded-full border border-border px-3 py-2 text-center">PDF</span>
      <span class="rounded-full border border-border px-3 py-2 text-center">Share</span>
    </div>
  </div>

  <footer class="flex flex-wrap justify-center gap-x-5 gap-y-2 pb-2 font-sans text-[0.68rem] uppercase tracking-[0.2em] text-muted-foreground">
    <a class="hover:text-accent" href="/impressum/">Legal Notice</a>
    <a class="hover:text-accent" href="/datenschutz/">Privacy</a>
    <a class="hover:text-accent" href="/nutzungsbedingungen/">Terms</a>
  </footer>
</section>
